import FirstRidersModule from "./firstRidersModule";
import FirstRidersSagas from "./redux/firstRidersSagas";
import FirstRidersReducer from "./redux/firstRidersReducer";

export default {
  Component: FirstRidersModule,
  moduleName: "firstRiders",
  saga: FirstRidersSagas(),
  reducer: FirstRidersReducer
};
